import * as AppPics from 'assets/images';
import Icons from '../../assets/Icons';

function Htmll() {
  return (
    <div className="mainWraper">
      <div className="tab">
        <ul className="tab__menu">
          <li className="back">
            <button className="btn-back">
              <img src={AppPics.BackSvg} alt="" />
            </button>
          </li>
          <li className="active">Notes</li>
        </ul>
        <div className="tab__content p-0">
          <div className="tab__content-actHead">
            <h3 className=" mt-2 bread-crump-nav">
              Course <Icons.BreadcrumbNavArrow /> Lesson <Icons.BreadcrumbNavArrow />
              <span>Test Sub Lesson 1</span>
            </h3>
          </div>
          <div className="tab p-0 app-l-tab-sub">
            <ul className="tab__menu">
              <li className="active">Commenting History</li>
              <li>Rating History</li>
            </ul>
            <div className="tab__content" style={{ display: 'none' }}>
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th scope="col">Sub Lesson’s Comment</th>
                    <th scope="col">Respondent</th>
                    <th scope="col">Status</th>
                    <th scope="col">Resolver</th>
                    <th scope="col"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>As the name resembles, it is the monomer</td>
                    <td>Reshmi</td>
                    <td>
                      <div className="icon">
                        <Icons.Unresolved />
                      </div>
                    </td>
                    <td>-</td>
                    <td>
                      <button type="button" class="btn btn-primary">
                        View
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>can be seen as</td>
                    <td>Reshmi</td>
                    <td>
                      <Icons.Resolved />
                    </td>
                    <td>Mini</td>
                    <td>
                      <button type="button" class="btn btn-primary">
                        View
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>considered an important type of</td>
                    <td>Deepa</td>
                    <td>
                      <div className="icon">
                        <Icons.Resolved />
                      </div>
                    </td>
                    <td>Mini</td>
                    <td>
                      <button type="button" class="btn btn-primary">
                        View
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>Can combine to form other molecules and produce water as a by….</td>
                    <td>Reshmi</td>
                    <td>
                      <div className="icon">
                        <Icons.Unresolved />
                      </div>
                    </td>
                    <td>-</td>
                    <td>
                      <button type="button" class="btn btn-primary">
                        View
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>Can combine to form other molecules and produce water as a by….</td>
                    <td>Reshmi</td>
                    <td>
                      <div className="icon">
                        <Icons.Unresolved />
                      </div>
                    </td>
                    <td>-</td>
                    <td>
                      <button type="button" class="btn btn-primary">
                        View
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>where, ni s the number of carbon atoms</td>
                    <td>Reshmi</td>
                    <td>
                      <div className="icon">
                        <Icons.Unresolved />
                      </div>
                    </td>
                    <td>Mini</td>
                    <td>
                      <button type="button" class="btn btn-primary">
                        View
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className="app-table-footer">
                <div>
                  <span>Lesson Author:</span>Nissy
                </div>
                <div>
                  <span>Lesson Vetting:</span>Incomplete
                </div>
                <div>
                  <span>Lesson Status:</span>Draft
                </div>
              </div>
            </div>
            <div className="tab__content">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th scope="col">Lesson’s Quality Rating</th>
                    <th scope="col">Rated by</th>
                    <th scope="col">Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <Icons.starIcon />
                      <Icons.starIcon />
                      <Icons.starIcon />
                    </td>
                    <td>Sudheer</td>
                    <td>19 Aug 2023</td>
                  </tr>
                  <tr>
                    <td>
                      <Icons.starIcon />
                      <Icons.starIcon />
                      <Icons.starIcon />
                      <Icons.starHalfIcon />
                    </td>
                    <td>Sudheer</td>
                    <td>19 Aug 2023</td>
                  </tr>
                  <tr>
                    <td>
                      <Icons.starIcon />
                      <Icons.starIcon />
                      <Icons.starIcon />
                      <Icons.starHalfIcon />
                    </td>
                    <td>Mini</td>
                    <td>19 Aug 2023</td>
                  </tr>
                </tbody>
              </table>
              <div className="app-table-footer-btn-block">
                <button type="button" className="btn-primary mx-3" style={{ minWidth: '24px' }}>
                  Modify Rating
                </button>
              </div>
              <div className="app-table-footer">
                <div>
                  <span>Lesson Author:</span>Nissy
                </div>
                <div>
                  <span>Lesson Vetting:</span>Incomplete
                </div>
                <div>
                  <span>Lesson Status:</span>Draft
                </div>
              </div>
            </div>
          </div>
          <div className="tab__content-actBody"></div>
          <div className="mb-5 btnTab-foot mt-5">
            <button className="btn-right-content save">Save Changes</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Htmll;
